import { IdeasCloseIcon } from "./IdeasIcons";

type ToolkitCardProps = React.PropsWithChildren<{
  close?: VoidFunction;
}>;

export default function ToolkitCard({ children, close }: ToolkitCardProps) {
  return (
    <div
      sx={{
        display: "flex",
        flexDirection: "column",
        border: "dt_card",
        borderRadius: "dt_radius_s",
        margin: "dt_m",
        padding: "dt_m",
        textAlign: "center",
        minHeight: 350,
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      {close && (
        <div sx={{ position: "absolute", top: 20, left: 20, zIndex: 10 }}>
          <IdeasCloseIcon onClick={close} />
        </div>
      )}
      {children}
    </div>
  );
}
